var exports = {
  "w6": "x127c5a35--aae782--comment_section_container",
  "C5": "x127c5a35--aae782--comment_section",
};

module.exports = exports;
